<section id="overview" class="section reveal reveal--fade-up" s2eReveal aria-labelledby="overview-heading">
  <div class="section__head">
    <div class="section__headings">
      <h2 class="section__title" id="overview-heading">{{ 'overview.title' | reportT }}</h2>
      <p class="section__desc">{{ 'overview.subtitle' | reportT: subtitleVars() }}</p>
    </div>
  </div>

  <div class="overview-grid">
    <article class="card card--interactive overview-donut" data-print-block>
      <div class="card-content overview-donut__content">
        <div class="donut" style="height:208px">
          <!-- Le composant ne rend que le SVG : le taux central et la légende
               restent ses frères, ce sont du texte traduit et formaté. -->
          <div class="donut__chart">
            <s2e-donut-chart
              [slices]="subject().charts.donut"
              [theme]="chrome.theme()"
              [ariaSummary]="donutAria()"
              [countFormat]="countFormat()"
              [percentFormat]="percentFormat()"
            />
          </div>
          <!-- Taux d'acquisition au-dessus du compte qui le produit. Aucune
               note ici : le /20 appartient au résumé. -->
          <div class="donut__center">
            <span class="donut__value">{{ subject().acquisition.acquiredPercentage | reportFmt: 'pct' }}</span>
            <span dir="ltr" class="donut__pct"><span>{{ subject().acquisition.acquired | reportFmt: 'num' }}</span> / <span>{{ subject().acquisition.total | reportFmt: 'num' }}</span></span>
          </div>
        </div>
        <ul class="chart-legend chart-legend--center">
          @for (entry of legend(); track entry.key) {
            <li class="chart-legend__item">
              <span class="chart-legend__swatch" [attr.data-swatch]="entry.key"
                    [style.background-color]="entry.color" aria-hidden="true"></span>
              <span class="chart-legend__label">{{ entry.label }}</span>
              <span class="chart-legend__count tabular">{{ entry.count | reportFmt: 'num' }}</span>
              <span class="chart-legend__value tabular">{{ entry.percentage | reportFmt: 'pct' }}</span>
            </li>
          }
        </ul>
      </div>
    </article>

    <div class="competency-grid">
      <article class="card card--interactive competency-card" data-print-block>
        <div class="competency-card__head">
          <p class="competency-card__label">{{ 'competency.acquiredLabel' | reportT }}</p>
          <span class="competency-card__chip competency-card__chip--acquired"><svg class="icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><circle cx="12" cy="12" r="10"/><path d="m9 12 2 2 4-4"/></svg></span>
        </div>
        <div class="competency-card__figures">
          <span class="competency-card__count tabular">{{ subject().acquisition.acquired | reportFmt: 'num' }}</span>
          <span class="competency-card__share tabular">{{ subject().acquisition.acquiredPercentage | reportFmt: 'pct' }}</span>
        </div>
        <div>
          <div class="competency-card__track competency-card__track--acquired" aria-hidden="true">
            <div class="competency-card__fill competency-card__fill--acquired reveal reveal--meter"
                 data-meter-fill
                 [style.--meter-target.%]="subject().acquisition.acquiredPercentage"
                 s2eReveal></div>
          </div>
          <p class="competency-card__note">{{ 'competency.total' | reportT: totalVars() }}</p>
        </div>
      </article>

      <article class="card card--interactive competency-card" data-print-block>
        <div class="competency-card__head">
          <p class="competency-card__label">{{ 'competency.notAcquiredLabel' | reportT }}</p>
          <span class="competency-card__chip competency-card__chip--notAcquired"><svg class="icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><circle cx="12" cy="12" r="10"/><path d="m15 9-6 6"/><path d="m9 9 6 6"/></svg></span>
        </div>
        <div class="competency-card__figures">
          <span class="competency-card__count tabular">{{ subject().acquisition.notAcquired | reportFmt: 'num' }}</span>
          <span class="competency-card__share tabular">{{ subject().acquisition.notAcquiredPercentage | reportFmt: 'pct' }}</span>
        </div>
        <div>
          <div class="competency-card__track competency-card__track--notAcquired" aria-hidden="true">
            <div class="competency-card__fill competency-card__fill--notAcquired reveal reveal--meter"
                 data-meter-fill
                 [style.--meter-target.%]="subject().acquisition.notAcquiredPercentage"
                 s2eReveal></div>
          </div>
          <p class="competency-card__note">{{ 'competency.total' | reportT: totalVars() }}</p>
        </div>
      </article>

      <article class="card card--interactive competency-card" data-print-block>
        <div class="competency-card__head">
          <p class="competency-card__label">{{ 'competency.notAssessedLabel' | reportT }}</p>
          <span class="competency-card__chip competency-card__chip--notAssessed"><svg class="icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M10.1 2.182a10 10 0 0 1 3.8 0"/><path d="M13.9 21.818a10 10 0 0 1-3.8 0"/><path d="M17.609 3.721a10 10 0 0 1 2.69 2.7"/><path d="M2.182 13.9a10 10 0 0 1 0-3.8"/><path d="M20.279 17.609a10 10 0 0 1-2.7 2.69"/><path d="M21.818 10.1a10 10 0 0 1 0 3.8"/><path d="M3.721 6.391a10 10 0 0 1 2.7-2.69"/><path d="M6.391 20.279a10 10 0 0 1-2.69-2.7"/></svg></span>
        </div>
        <div class="competency-card__figures">
          <span class="competency-card__count tabular">{{ subject().acquisition.notAssessed | reportFmt: 'num' }}</span>
          <span class="competency-card__share tabular">{{ subject().acquisition.notAssessedPercentage | reportFmt: 'pct' }}</span>
        </div>
        <div>
          <div class="competency-card__track competency-card__track--notAssessed" aria-hidden="true">
            <div class="competency-card__fill competency-card__fill--notAssessed reveal reveal--meter"
                 data-meter-fill
                 [style.--meter-target.%]="subject().acquisition.notAssessedPercentage"
                 s2eReveal></div>
          </div>
          <p class="competency-card__note">{{ 'competency.total' | reportT: totalVars() }}</p>
        </div>
      </article>
    </div>

    <article class="card overview-takeaway" data-print-block>
      <div class="card-content callout callout--wide">
        <span class="callout__icon"><svg class="icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5.7.7 1.3 1.5 1.5 2.5"/><path d="M9 18h6"/><path d="M10 22h4"/></svg></span>
        <div class="callout__text">
          <p class="callout__title">{{ 'overview.recommendationTitle' | reportT }}</p>
          <p class="callout__body">{{ planDescription() }}</p>
        </div>
      </div>
    </article>
  </div>
</section>
